var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.8 13.387c-.907-4.6-4.947-8.054-9.8-8.054a9.996 9.996 0 0 0-8.867 5.387A7.993 7.993 0 0 0 0 18.667c0 4.413 3.587 8 8 8h17.333A6.67 6.67 0 0 0 32 20c0-3.52-2.733-6.373-6.2-6.613zm-7.133 3.946v5.334h-5.334v-5.334h-4L16 10.667l6.667 6.666h-4z"
})));
export default SvgCloudUpload;